import { useEffect, useState } from "react";
import { InlineWidget, useCalendlyEventListener } from "react-calendly";
import "../styles/ScheduleMeeting.css";
import { useQuery } from "@tanstack/react-query";
import { checkSubmissionId } from "services/getApis";
import { useNavigate, useParams } from "react-router-dom";
import { ErrorToast } from "utils/toast";
import LoaderPulse from "components/Loader/LoaderPulse";

const ScheduleMeeting = () => {
  const [scheduledEvent, setScheduledEvent] = useState(null);
  const { submissionId } = useParams();
  const navigate = useNavigate();

  const { isLoading, isError } = useQuery({
    queryKey: ["scheduledEvent", submissionId],
    queryFn: () => checkSubmissionId(submissionId),
    enabled: !!submissionId,
    retry: 3,
  });

  useEffect(() => {
    if (isError) {
      ErrorToast(
        "Invalid submission ID. Please complete the questionnaire first.",
      );
      navigate("/questionnaire", { replace: true });
    }
  }, [isError, navigate]);

  // Check localStorage on mount
  useEffect(() => {
    const savedEvent = localStorage.getItem("scheduledMeeting");
    if (savedEvent) {
      setScheduledEvent(JSON.parse(savedEvent));
    }
  }, []);

  useCalendlyEventListener({
    // onProfilePageViewed: (e) => console.log("onProfilePageViewed", e),
    // onCalendarPageViewed: (e) => console.log("onCalendarPageViewed", e),
    // onDateAndTimeSelected: (e) => console.log("onDateAndTimeSelected", e),
    // onEventTypeViewed: (e) => console.log("onEventTypeViewed", e),
    // onEventScheduled: (e) => console.log("onEventScheduled", e),
    // onPageHeightResize: (e) => console.log("onPageHeightResize", e),
    onEventScheduled: (e) => {
      console.log("onEventScheduled", e);
      // Save to localStorage so it persists after refresh
      const eventData = {
        scheduled: true,
        eventUri: e.data.payload.event.uri,
        inviteeUri: e.data.payload.invitee.uri,
        scheduledAt: new Date().toISOString(),
      };
      localStorage.setItem("scheduledMeeting", JSON.stringify(eventData));
      setScheduledEvent(eventData);
    },
  });

  // Show confirmation if already scheduled
  if (scheduledEvent) {
    return (
      <div className="schedule-container scheduled-bg">
        <div className="scheduled-confirmation">
          <div className="confirmation-card">
            <div className="success-animation">
              <div className="checkmark-circle">
                <svg className="checkmark" viewBox="0 0 52 52">
                  <circle
                    className="checkmark-circle-bg"
                    cx="26"
                    cy="26"
                    r="25"
                    fill="none"
                  />
                  <path
                    className="checkmark-check"
                    fill="none"
                    d="M14.1 27.2l7.1 7.2 16.7-16.8"
                  />
                </svg>
              </div>
            </div>
            <h2 className="confirmation-title">You're All Set!</h2>
            <p className="confirmation-desc">
              Your consultation has been successfully scheduled.
            </p>
            <div className="confirmation-divider"></div>
            <div className="confirmation-info">
              <div className="info-item">
                <span className="info-icon">📧</span>
                <span className="info-text">
                  Calendar invitation sent to your email
                </span>
              </div>
              <div className="info-item">
                <span className="info-icon">🔔</span>
                <span className="info-text">
                  You'll receive a reminder before the meeting
                </span>
              </div>
              <div className="info-item">
                <span className="info-icon">💻</span>
                <span className="info-text">
                  Web conferencing details will follow
                </span>
              </div>
            </div>
            <button
              className="home-button"
              onClick={() => {
                localStorage.removeItem("scheduledMeeting");
                navigate("/", { replace: true });
              }}
            >
              Back to Home
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="schedule-container">
      <div className="schedule-header">
        {isLoading ? (
          <div
            style={{
              marginTop: "15%",
            }}
          >
            <LoaderPulse />
          </div>
        ) : (
          <>
            <h1 className="schedule-title">Schedule Consultation</h1>
            <p className="schedule-desc">
              Select a slot that fits your schedule
            </p>
            <div className="calendly-wrapper">
              <InlineWidget
                url="https://calendly.com/satyam-narayan-silversky/30min?hide_gdpr_banner=1"
                // url="https://calendly.com/nileshsilversky/45-minute-meeting?embed=true"
                styles={{
                  height: "700px",
                  overflow: "hidden",
                }}
                pageSettings={{
                  hideEventTypeDetails: false,
                  hideLandingPageDetails: false,
                  hideGdprBanner: true,
                }}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ScheduleMeeting;
